import Vue from "vue";
import Router, {RouterOptions, RouteConfig} from "vue-router";
import {checkNotNewAuthenticated, checkNewAuthenticated} from "./guards";
import VueRouter from "vue-router";

const NewAuth = () => import(/* webpackChunkName: "new-auth" */"@/components/newAuth/NewAuth.vue");

const Workspaces   = () => import(/* webpackChunkName: "workspaces" */ "@/components/beta/Workspaces.vue");
const MailingList  = () => import(/* webpackChunkName: "workspaces" */ "@/components/beta/MailingList.vue");
const PageNotFound = () => import(/* webpackChunkName: "page-not-found" */ "@/components/beta/PageNotFound.vue");
const Logout       = () => import(/* webpackChunkName: "logout" */ "@/components/beta/Logout.vue");
const Settings     = () => import(/* webpackChunkName: "settings" */ "@/components/beta/Settings.vue");
const Shards       = () => import(/* webpackChunkName: "shards" */ "@/components/beta/Shards.vue");
const Show         = () => import(/* webpackChunkName: "show" */ "@/components/beta/Show.vue");
const CompanySettings = () => import(/* webpackChunkName: "company-settings" */ "@/components/beta/CompanySettings.vue");
const PageStatistics = () => import(/* webpackChunkName: "page-statistics" */ "@/components/beta/NewStatistics/PageStatistics.vue");
const Proxy = () => import(/* webpackChunkName: "proxy" */ "@/components/beta/Proxy.vue");

Vue.use(Router);

const routes: RouteConfig[] = [
    {
        path: "/",
        name: "NewAuth",
        component: NewAuth,
        beforeEnter: (to, from, next) => {
            checkNotNewAuthenticated(to, from, next).then(() => {
                next();
            }).catch(() => {
                next({name: 'Workspaces'})
            });
        },
    },

    {
        path: "/w/:code/:showCode",
        name: "Show",
        component: Show,
        meta: {layout: 'LayoutFull'},
        beforeEnter: (to, from, next) => {
            checkNewAuthenticated(to, from, next).then(() => {
                next();
            });
        },
        children: [
            {
                path: "settings",
                name: "Settings",
                component: Settings,
                meta: {layout: 'LayoutFull'},
            },
            {
                path: "shards",
                name: "Shards",
                component: Shards,
                meta: {layout: 'LayoutFull'},
            },
            {
                path: "statistic",
                name: "Statistics",
                component: PageStatistics,
                meta: {layout: 'LayoutFull'},
            },
            {
                path: "mailing-list",
                name: "MailingList",
                component: MailingList,
                meta: {layout: 'LayoutFull'},
            },
        ]
    },
    {
        path: "/:companyCode/company-settings",
        name: "CompanySettings",
        component: CompanySettings,
        beforeEnter: (to, from, next) => {
            checkNewAuthenticated(to, from, next).then(() => {
                next();
            });
        },
    },
    {
        path: "/w",
        name: "Workspaces",
        component: Workspaces,
        beforeEnter: (to, from, next) => {
            checkNewAuthenticated(to, from, next).then(() => {
                next();
            });
        },
    },
    {
        path: "/w/:code",
        name: "Corporate",
        component: Proxy,
        props: true,
        meta: {layout: 'Layout'},
        beforeEnter: (to, from, next) => {
            checkNewAuthenticated(to, from, next).then(() => {
                next();
            });
        },
    },
    {
        path: "/logout",
        name: "Logout",
        component: Logout,
        meta: {layout: 'none'}
    },
    {path: "*", component: PageNotFound}
];

const options: RouterOptions = {
    mode: "history",
    base: process.env.BASE_URL,
    routes,
};

const router = new VueRouter(options);

router.beforeEach(async (to, from, next) => {
    if (to.name === 'Corporate') {
        const store = await import('@/store');  //await the store
        // let comp = store.default.getters['profile/userCompanies']
        store.default.commit('profile/setCurrentWorkspace', to.params.code)
        localStorage.setItem('workspace', to.params.code)
    }
    next()
})


export default router;


